import { CapitalizePipe } from './../shared/pipes/capitalize.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScoreCardComponent } from './score-card/score-card.component';
import { MatTableModule, MatButtonModule, MatRadioModule, MatDialogModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { DupeNamePipe } from '../shared/pipes/dupe-name.pipe';
import { ResultsDialogComponent } from './results-dialog/results-dialog.component';




@NgModule({
  declarations: [ScoreCardComponent, CapitalizePipe, DupeNamePipe, ResultsDialogComponent],
  imports: [
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    MatDialogModule
  ],
  entryComponents: [
    ResultsDialogComponent
  ]
})
export class MatchModule { }
